import { render } from "./Finder.vue?vue&type=template&id=2cffe499&scoped=true&bindings={\"label\":\"props\",\"handleClick\":\"options\",\"handleKeyDown\":\"options\"}"
import script from "./Finder.vue?vue&type=script&lang=js"
export * from "./Finder.vue?vue&type=script&lang=js"

import "./Finder.vue?vue&type=style&index=0&id=2cffe499&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2cffe499"

export default script